<script setup lang="ts">
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'

const props = defineProps<{ mode: 'ONLINE_ONLY' | 'PLAYER_CHOICE' | 'ON_SITE'; initial: 'online' | 'on_site' }>()
const { t } = useI18n()
const choice = ref(props.initial)
</script>

<template>
  <fieldset v-if="mode === 'PLAYER_CHOICE'" class="grid gap-2">
    <legend class="mb-2 font-bold">{{ t('player.checkout.payment') }}</legend>
    <label class="flex cursor-pointer items-center gap-3 rounded-xl border border-base-300 p-3">
      <input v-model="choice" class="radio radio-primary" type="radio" name="payment_choice" value="online">
      <span>{{ t('player.checkout.online') }}</span>
    </label>
    <label class="flex cursor-pointer items-center gap-3 rounded-xl border border-base-300 p-3">
      <input v-model="choice" class="radio radio-primary" type="radio" name="payment_choice" value="on_site">
      <span>{{ t('player.checkout.on_site') }}</span>
    </label>
  </fieldset>
  <input v-else type="hidden" name="payment_choice" :value="mode === 'ON_SITE' ? 'on_site' : 'online'">
</template>
